import { render, staticRenderFns } from "./DialogOptimizedPOS.vue?vue&type=template&id=bbcf88d8"
import script from "./DialogOptimizedPOS.vue?vue&type=script&lang=js"
export * from "./DialogOptimizedPOS.vue?vue&type=script&lang=js"
import style0 from "./DialogOptimizedPOS.vue?vue&type=style&index=0&id=bbcf88d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports